module.exports = __webpack_public_path__ + "img/TRAVER-logo.1cbce548.jpg";